import { supabase } from '@/lib/supabase'
import type { RewardsExchange } from '../types'

export type RewardsAffiliateUuidRow = {
  id: string
  exchange: RewardsExchange
  affiliate_uuid: string
  active: boolean
  created_at: string
  updated_at: string
}

export async function listRewardsAffiliateUuids(exchange: RewardsExchange): Promise<RewardsAffiliateUuidRow[]> {
  const { data, error } = await supabase
    .from('rewards_exchange_affiliate_uuids')
    .select('id,exchange,affiliate_uuid,active,created_at,updated_at')
    .eq('exchange', exchange)
    .order('created_at', { ascending: false })
  if (error) throw error
  return ((data || []) as any[]).map((r) => ({
    id: r.id,
    exchange: r.exchange,
    affiliate_uuid: r.affiliate_uuid,
    active: !!r.active,
    created_at: r.created_at,
    updated_at: r.updated_at,
  }))
}

export async function createRewardsAffiliateUuid(params: { exchange: RewardsExchange; affiliateUuid: string; active: boolean }): Promise<void> {
  const uuid = String(params.affiliateUuid || '').trim()
  if (!uuid) throw new Error('Informe o Affiliate UUID')
  if (uuid.length > 120) throw new Error('Affiliate UUID muito longo')

  if (params.active) {
    await supabase
      .from('rewards_exchange_affiliate_uuids')
      .update({ active: false })
      .eq('exchange', params.exchange)
  }

  const { error } = await supabase
    .from('rewards_exchange_affiliate_uuids')
    .insert({ exchange: params.exchange, affiliate_uuid: uuid, active: params.active } as any)
  if (error) throw error
}

export async function setRewardsAffiliateUuidActive(params: { exchange: RewardsExchange; id: string }): Promise<void> {
  const id = String(params.id || '').trim()
  if (!id) throw new Error('UUID inválido')

  const clear = await supabase
    .from('rewards_exchange_affiliate_uuids')
    .update({ active: false })
    .eq('exchange', params.exchange)
  if (clear.error) throw clear.error

  const set = await supabase
    .from('rewards_exchange_affiliate_uuids')
    .update({ active: true })
    .eq('id', id)
    .eq('exchange', params.exchange)
  if (set.error) throw set.error
}

